export default __webpack_public_path__ + "c39b4bef8a9a2568d95e92de962e8468.svg";